import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { SkipTestModalComponent } from './components/skip-test-modal/skip-test-modal.component';
import { TextMessageComponent } from './components/text-message/text-message.component';
import { PhoneDiagnosticsComponent } from './phone-diagnostics.component';
import { PhoneOnboardingComponent } from './phone-onboarding/phone-onboarding.component';
import { PostDiagnosticLandingPageComponent } from './components/post-diagnostic-landing-page/post-diagnostic-landing-page.component';
import { RegisterNumberComponent } from './components/register-number/register-number.component';
import { ConfirmNumberComponent } from './components/confirm-number/confirm-number.component';
import { PhoneRegistrationComponent } from './phone-registration/phone-registration.component';
import { AdditionalDeviceQuestionnaireComponent } from './components/additional-device-questionnaire/additional-device-questionnaire.component';
import { AdditionalDeviceSelectionComponent } from './components/additional-device-selection/additional-device-selection.component';
import { TabletRegistrationComponent } from './tablet-registration/tablet-registration.component';
import { SmartwatchRegistrationComponent } from './smartwatch-registration/smartwatch-registration.component';
import { DamageQuestionnaireComponent } from './components/damage-questionnaire/damage-questionnaire.component';
import { ImeiLookupComponent } from './components/imei-lookup/imei-lookup.component';
import { ImeiQuestionnaireComponent } from './components/imei-questionnaire/imei-questionnaire.component';
import { ArrayObjectSelectorModule } from 'src/app/shared/array-object-selector/array-object-selector.module';
import { QRCodeModule } from 'angularx-qrcode';
import { SerialLookupComponent } from './components/serial-lookup/serial-lookup.component';
import { ScanQRCodeComponent } from './components/scan-qrcode/scan-qrcode.component';
import { ResumeDiagnosticTestModalComponent } from './components/resume-diagnostic-test-modal/resume-diagnostic-test-modal.component';
import { NonCellularDeviceInfoFormComponent } from './components/non-cellular-device-info-form/non-cellular-device-info-form.component';
import { CellularDeviceInfoFormComponent } from './components/cellular-device-info-form/cellular-device-info-form.component';
import { CellularEnabledInfoModalComponent } from './components/cellular-enabled-info-modal/cellular-enabled-info-modal.component';

@NgModule({
  declarations: [
    LandingPageComponent,
    SkipTestModalComponent,
    TextMessageComponent,
    TabletRegistrationComponent,
    SmartwatchRegistrationComponent,
    AdditionalDeviceQuestionnaireComponent,
    AdditionalDeviceSelectionComponent,
    DamageQuestionnaireComponent,
    ImeiLookupComponent,
    ImeiQuestionnaireComponent,
    SerialLookupComponent,
    ScanQRCodeComponent,
    ResumeDiagnosticTestModalComponent,
    CellularEnabledInfoModalComponent,
    CellularDeviceInfoFormComponent,
    NonCellularDeviceInfoFormComponent,
    PhoneDiagnosticsComponent,
    PhoneOnboardingComponent,
    PostDiagnosticLandingPageComponent,
    PhoneRegistrationComponent,
    RegisterNumberComponent,
    ConfirmNumberComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    FormsModule,
    SharedModule,
    QRCodeModule,
    ArrayObjectSelectorModule
  ],
  exports: [
    ImeiLookupComponent,
    CellularDeviceInfoFormComponent,
    NonCellularDeviceInfoFormComponent,
  ]
})
export class DeviceDiagnosticsModule { }
